
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/shop",
      function () {
        return require("private-next-pages/[domain]/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/shop"])
      });
    }
  